export const getCurrentAlert = (state) => state.alerts[0] || {};
